import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import LatestTopics from "@/pages/home/components/LatestTopics";
import TagCloud from "@/pages/home/components/TagCloud";
import FeaturedBanner from "@/pages/home/components/FeaturedBanner";
import AboutIntro from "@/pages/home/components/AboutIntro";

export default function Home() {
  return (
    <>
      <HeroCarousel />
      <CategoryQuickLinks />
      <LatestTopics />
      <TagCloud />
      <FeaturedBanner />
      <AboutIntro />
    </>
  );
}